import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { StrikeWeightRatioDesignMode, type StrikeWeightRatioDesignTarget } from '@/lib/piano/touch-design/design/strike-weight-ratio-design';
import { SmoothStrategy } from '@/lib/geometry/curve-smoother/smooth-strategy.enum';
export const useStrikeWeightRatioRecommendation = (strikeWeightRatioDesignMode, strikeWeightRatioDesignTarget, setStrikeWeightRatioDesign) => {
  const $ = _c(5);
  const isFirstRender = useRef(true);
  let t0;
  let t1;
  if ($[0] !== setStrikeWeightRatioDesign || $[1] !== strikeWeightRatioDesignMode || $[2] !== strikeWeightRatioDesignTarget) {
    t0 = () => {
      if (isFirstRender.current) {
        if (strikeWeightRatioDesignMode === null && strikeWeightRatioDesignTarget === null) {
          setStrikeWeightRatioDesign(StrikeWeightRatioDesignMode.Smoothed, SmoothStrategy.Median);
        }
        isFirstRender.current = false;
      }
    };
    t1 = [isFirstRender, setStrikeWeightRatioDesign, strikeWeightRatioDesignMode, strikeWeightRatioDesignTarget];
    $[0] = setStrikeWeightRatioDesign;
    $[1] = strikeWeightRatioDesignMode;
    $[2] = strikeWeightRatioDesignTarget;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};